import Swal from 'sweetalert2';
import { authHeader } from './authHeader';

var url_json = require("../location.json");

if (window.location.origin.includes("localhost")) {
    url_json = url_json.local;
} else {
    url_json = url_json.production;
}

const Noticias = {
    agregarNoticia: async (data) => {
        let url = url_json + "/noticia"
        let body = {
            imagen: data.imagen,
            url: data.url ?? '',
            descripcion: data.descripcion ?? '',
            orden: Number(data.orden) || 0
        };
        let request = {
            method: 'POST',
            body: JSON.stringify(body),
            headers: authHeader()
        }

        let response = await fetch(url, request);
        let res = await response.json();

        if (response.ok) {
            Swal.fire(
              'Inserción exitosa!',
              'Noticia agregada correctamente' ,
              'success'
            )
        } else {
            Swal.fire(
                'Error!',
                'No se pudo guardar la noticia, codigo: ' + res.message ,
                'error'
            )
        }
        return { success: response.ok, data: res.data, code: res.message };
    },
    obtenerNoticias: async () => {
        let url = url_json + "/noticia"
        let request = {
            method:'GET',
            headers: authHeader()
        }

        let response = await fetch(url, request);
        let json = await response.json();
        return { success: response.ok, data: json.data, code: json.message };
    },
    editarNoticia: async (data, id) => {
        let url = url_json + "/noticia/" + id;
        let body = {
            imagen: data.imagen,
            url: data.url ?? '',
            descripcion: data.descripcion ?? '',
            orden: Number(data.orden) || 0
        };
        let request = {
            method: 'PATCH',
            body: JSON.stringify(body),
            headers: authHeader()
        }

        let response = await fetch(url, request);
        let res = await response.json();
        if (response.ok) {
            Swal.fire(
                'Modificación exitosa!',
                'Noticia modificada correctamente' ,
                'success'
            )
        } else {
            Swal.fire(
                'Error!',
                'No se pudo modificar la noticia' ,
                'error'
            )
        }
        return { success: response.ok, data: res.data };
    },
    eliminarNoticia: async id => {
        let url = url_json + "/noticia/delete/" + id;
        let request = {
            method: 'PATCH',
            headers: authHeader()
        }

        let response = await fetch(url, request);
        let res = await response.json();
        if (response.ok) {
            Swal.fire(
                'Eliminación exitosa!',
                'Noticia eliminada correctamente' ,
                'success'
            )
        } else {
            Swal.fire(
                'Error!',
                'No se pudo eliminar la noticia' ,
                'error'
            )
        }
        return { success: response.ok, data: res.data };
    }
}

export default Noticias;
